import React from "react";
import { MdClose } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import classes from "./MobileNavStyles.module.css";

interface Props {
  onCLosehandler: () => void;
}

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  // { label: "Driver", to: "/rider" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const MobileNav: React.FC<Props> = ({ onCLosehandler }) => {
  const location = useLocation();

  return (
    <div className={classes.container}>
      <button
        className={classes.close_container}
        onClick={onCLosehandler}
        aria-label="Close menu"
      >
        <MdClose size={20} />
      </button>

      <div className={classes.wrapper}>
        <ul>
          {NAV_LINKS.map((link, index) => (
            <li
              key={link.to}
              style={{ animationDelay: `${0.05 * index}s` }}
            >
              <Link
                to={link.to}
                className={
                  location.pathname === link.to ? classes.active : ""
                }
                onClick={onCLosehandler}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <Link to={"/rider"} onClick={onCLosehandler} className={classes.ctaLink}>
          <button className={classes.download_btn}>Drive with Us</button>
        </Link>
      </div>
    </div>
  );
};

export default MobileNav;